import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TAddress } from '@shared/types/organization';

export const editUserAddress = async ({
  userId,
  ...data
}: TAddress & { userId: number }) => {
  const id = data.id;
  return await request({
    url: id
      ? `members/${userId}/addresses/${id}`
      : `members/${userId}/addresses/`,
    method: id ? 'PATCH' : 'POST',
    body: data,
  });
};

export const useEditUserAddress = () => {
  return useMutation({
    mutationFn: editUserAddress,
    onError: (error: string) => {
      toast.error(error);
    },
    onSuccess: () => {
      toast.success('User Address has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getUserById],
      });
    },
  });
};
